import { EntityOption } from '@context/shared/types/common';
import { User } from '../types';
import { getName } from '../utils';

export class UserOption extends EntityOption<User> {
	protected override toString() {
		return getName(this.data);
	}
}
